import { useState, useMemo } from "react";
import TableList from "../TableList/TableList";

const personnel = [
  { id: "1", name: "Ana García", role: "Gerente", branchId: "1" },
  { id: "2", name: "Carlos Ruiz", role: "Vendedor", branchId: "1" },
  { id: "3", name: "Elena Torres", role: "Supervisor", branchId: "2" },
  { id: "4", name: "David M.", role: "Vendedor", branchId: "2" },
  { id: "5", name: "Lucía P.", role: "Cajera", branchId: "3" },
  { id: "6", name: "Marcos L.", role: "Gerente", branchId: "4" },
  { id: "7", name: "Sofia R.", role: "Vendedor", branchId: "4" },
  { id: "8", name: "Javier B.", role: "Logística", branchId: "5" },
];

export default function AssignProspects({ campaigns }) {
  console.log("las campañas que llegan a asignar prospectos", campaigns); //llegan bien

  const branches = [
    {
      id: "1",
      name: "Sucursal Centro",
      location: "Catamarca",
      campaignIds: ["1", "2", "4"],
    },
    {
      id: "2",
      name: "Valle Viejo",
      location: "Catamarca",
      campaignIds: ["1", "3", "5"],
    },
    { id: "3", name: "Belen", location: "Catamarca", campaignIds: ["2", "4"] },
    {
      id: "4",
      name: "Andalgala",
      location: "Catamarca",
      campaignIds: ["1", "2", "3", "4", "5"],
    },
    { id: "5", name: "Recreo", location: "Catamarca", campaignIds: ["1"] },
  ];

  // estados
  const [selectedCampaigns, setSelectedCampaigns] = useState(new Set());
  const [selectedBranches, setSelectedBranches] = useState(new Set());
  const [selectedPersonnel, setSelectedPersonnel] = useState(new Set());

  const [searchCampaign, setSearchCampaign] = useState("");
  const [searchBranch, setSearchBranch] = useState("");
  const [searchPerson, setSearchPerson] = useState("");

  const campaignsList = useMemo(() => {
    if (!campaigns) return [];

    return campaigns
      .map((c) => ({
        id: c.id,
        name: c.prospectsName,
      }))
      .filter((c) =>
        c.name.toLowerCase().includes(searchCampaign.toLowerCase())
      );
  }, [campaigns, searchCampaign]);

  // Filtrado de personal según las sucursales seleccionadas
  const filteredPersonnel = useMemo(() => {
    return personnel.filter((person) =>
      selectedBranches.size === 0 ? true : selectedBranches.has(person.branchId)
    );
  }, [selectedBranches]);

  return (
    <div className="space-y-4">
      <div className="rounded-2xl bg-white shadow-sm p-5">
        <h2 className="text-2xl font-bold">Asignación de prospectos</h2>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Tarjeta de campañas */}
        <TableList
          title="Asignación de prospectos"
          items={campaignsList}
          selectedId={selectedCampaigns}
          onToggle={(id) => {
            const updated = new Set(selectedCampaigns);
            updated.has(id) ? updated.delete(id) : updated.add(id);
            setSelectedCampaigns(updated);
          }}
          onClear={() => setSelectedCampaigns(new Set())}
          placeholderSearch="Buscar..."
          searchValue={searchCampaign}
          onSearchChange={setSearchCampaign}
        />

        {/* Mostrar tarjeta de sucursales siempre, sin importar las campañas seleccionadas */}
        {selectedCampaigns.size > 0 && (
          <TableList
            title="Asignación de prospectos"
            items={branches}
            selectedId={selectedBranches}
            onToggle={(id) => {
              const updated = new Set(selectedBranches);
              updated.has(id) ? updated.delete(id) : updated.add(id);
              setSelectedBranches(updated);
            }}
            onClear={() => setSelectedBranches(new Set())}
            placeholderSearch="Buscar..."
            searchValue={searchBranch}
            onSearchChange={setSearchBranch}
          />
        )}

        {/* Mostrar tarjeta de personal solo si hay algo seleccionado en sucursales */}
        {selectedBranches.size > 0 && (
          <TableList
            title="Asignación de personal"
            items={filteredPersonnel.filter((p) =>
              p.name.toLowerCase().includes(searchPerson.toLowerCase())
            )}
            selectedId={selectedPersonnel}
            onToggle={(id) => {
              const updated = new Set(selectedPersonnel);
              updated.has(id) ? updated.delete(id) : updated.add(id);
              setSelectedPersonnel(updated);
            }}
            onClear={() => setSelectedPersonnel(new Set())}
            placeholderSearch="Buscar..."
            searchValue={searchPerson}
            onSearchChange={setSearchPerson}
          />
        )}
      </div>
    </div>
  );
}
